/**
 * Color token definitions using CSS custom properties.
 * These reference variables that should be defined in the consuming app's
 * global CSS (typically via Tailwind v4 theme configuration).
 *
 * Light/dark mode is handled at the CSS variable level, not here.
 */

export const colors = {
    background: "var(--color-background)",
    foreground: "var(--color-foreground)",

    primary: {
        DEFAULT: "var(--color-primary)",
        foreground: "var(--color-primary-foreground)",
    },
    secondary: {
        DEFAULT: "var(--color-secondary)",
        foreground: "var(--color-secondary-foreground)",
    },
    muted: {
        DEFAULT: "var(--color-muted)",
        foreground: "var(--color-muted-foreground)",
    },
    accent: {
        DEFAULT: "var(--color-accent)",
        foreground: "var(--color-accent-foreground)",
    },
    destructive: {
        DEFAULT: "var(--color-destructive)",
        foreground: "var(--color-destructive-foreground)",
    },
    success: {
        DEFAULT: "var(--color-success)",
        foreground: "var(--color-success-foreground)",
    },
    warning: {
        DEFAULT: "var(--color-warning)",
        foreground: "var(--color-warning-foreground)",
    },

    border: "var(--color-border)",
    ring: "var(--color-ring)",

    card: {
        DEFAULT: "var(--color-card)",
        foreground: "var(--color-card-foreground)",
        background: "var(--color-card-background)",
    },

    text: {
        DEFAULT: "var(--color-text-body)",
        eyebrow: "var(--color-text-eyebrow)",
        heading: "var(--color-text-heading)",
        body: "var(--color-text-body)",
        muted: "var(--color-text-muted)",
        caption: "var(--color-text-caption)",
        link: "var(--color-text-link)",
        white: "var(--color-text-white)",
        soft: "var(--color-text-soft)",
    },

    sidebar: {
        DEFAULT: "var(--color-sidebar)",
        foreground: "var(--color-sidebar-foreground)",
        mutedForeground: "var(--color-sidebar-muted-foreground)",
        primary: "var(--color-sidebar-primary)",
        primaryForeground: "var(--color-sidebar-primary-foreground)",
        accent: "var(--color-sidebar-accent)",
        accentForeground: "var(--color-sidebar-accent-foreground)",
        border: "var(--color-sidebar-border)",
        ring: "var(--color-sidebar-ring)",
    },
} as const;
